<template>
  <div>
    <el-form :model="form" :inline="true" size="mini" label-width="90px">
      <el-form-item style="float: right;">
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button type="warning" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="SPU名称" prop="spuName">
        <el-input v-model.trim="form.spuName" placeholder="请输入SPU名称"></el-input>
      </el-form-item>
      <el-form-item label="SPU品类" prop="spuCategory">
        <el-input v-model.trim="form.spuCategory" placeholder="请输入SPU品类"></el-input>
      </el-form-item>
      <el-form-item label="SKU名称" prop="skuName">
        <el-input v-model.trim="form.skuName" placeholder="请输入SKU名称"></el-input>
      </el-form-item>
      <el-form-item label="SKU编码" prop="skuCode">
        <el-input v-model.trim="form.skuCode" placeholder="请输入SKU编码"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: ['formData'],
  data() {
    return {
      collapse: false,
      form: {}
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    onSearch() {
      this.$emit('search', this.form)
    },
    onReset() {
      this.form = {};
      this.$nextTick(_=>{
        this.onSearch();
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
  >>> .el-form
    width 100%
    margin-top 5px
  >>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item
    margin-bottom: 5px !important
  .search-header-collapse 
    position absolute
    background-color #ffffff
    width 100%
    left 0px
    padding 10px 10px 0
    margin-top -5px
    box-sizing border-box
    z-index 999
    box-shadow 0px 5px 5px rgba(0,0,0,.1)

  >>> .table-input input
    height 18px
    line-height 18px
    padding 0 10px
    text-align right
    width 45px
</style>